<template>
  <media-manager
    v-bind:title="'Public'"
    v-bind:containers="[publicContainer]"
    v-bind:defaultContainer="publicContainer.name"
  />
</template>

<script>
import MediaManager from '@/components/MediaManager'
import { Container } from '@/config.js'

export default {
  name: 'PublicMediaLibrary',
  components: {
    MediaManager
  },
  data() {
    return {
      publicContainer: {
        name: Container.Public,
        displayName: 'Public'
      }
    }
  }
}
</script>
